import { SelectBox, Toolbar } from "devextreme-react";
import { useState, useEffect } from "react";
import { PostData } from "../../../Helper";
import "../../../tailwind.css";
const ClassroomAttendance = () => {
  const [classrooms, setClassrooms] = useState([]);
  useEffect(() => {
    PostData({
      url: "classroom",
      showLoading: false,
      success: (e) => setClassrooms(e),
    });
  }, []);

  return (
    <div className="p-2">
      <div className="border-b-2">
        <div className="w-12">
          <span>Kelas</span>
          <SelectBox className="w-12" dataSource={classrooms} displayExpr="name" valueExpr="id" />
        </div>
      </div>
    </div>
  );
};

export default ClassroomAttendance;
